var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHelp)?_c('span',{staticClass:"characters-available",class:{'danger': _vm.counter < 10}},[_vm._v(_vm._s(_vm.counter)+" Caracteres Disponibles")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }